import { BaseRestDataProvider } from './BaseRestDataProvider';
import { ReferenceNumberConfig } from '../models/ReferenceNumberConfig';

export class ReferenceNumberConfigRestDataProvider extends BaseRestDataProvider {
    constructor() {
        super('/v1/reference-numbers');
    }

    getAll(): Promise<ReferenceNumberConfig[]> {
        return this.get<ReferenceNumberConfig[]>(``);
    }

    getById(id: string): Promise<ReferenceNumberConfig> {
        return this.get<ReferenceNumberConfig>(`/${id}`);
    }

    update(id: string, config: ReferenceNumberConfig): Promise<void> {
        return this.put<void>(`/${id}`, config) as Promise<void>;
    }

    peek(configKey: string): Promise<{ formattedNumber: string }> {
        return this.get<{ formattedNumber: string }>(`/peek/${configKey}`);
    }

    async commit(configKey: string): Promise<string> {
        const token = BaseRestDataProvider.getToken();
        const response = await fetch(`${this.baseUrl}/commit/${configKey}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        });
        if (!response.ok) {
            throw new Error(await response.text());
        }
        const data: { committedNumber: string } = await response.json();
        return data.committedNumber;
    }
}
